import {
  Component, Inject, Vue,
} from 'vue-property-decorator';
import WithRender from './business-persona.html';
import BasePersona from '../base-persona/BasePersona';
import SharedDataService from '@/modules/shared/services/sharedDataService';

@WithRender
@Component({
  components: {
    BasePersona,
  },
})
export default class BusinessPersona extends Vue {
  @Inject()
  public sharedDataService!:SharedDataService;
  public get target() {
    return [this.sharedDataService.Personas.BUSINESS];
  }
}
